import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { UserRole } from '../types/user';

export default function ProtectedRoute({ allowedRoles }: { allowedRoles?: UserRole[] }): React.JSX.Element {
  const { isAuthenticated, isLoading, user, error } = useAuth();
  if (isLoading) return <div className="px-6 py-20 text-center text-slate-600">Loading your account…</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (error) return <div className="px-6 py-20 text-center text-red-700">{error}</div>;
  if (!user) return <div className="px-6 py-20 text-center text-slate-600">Unable to load your profile.</div>;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
